import React, {Fragment, useEffect, useRef, useState} from 'react';
import {connect} from "react-redux";
import image from "../../assets/img/8244 (1).jpg";
import {BASE_URL} from '../../utils/web-config'
import {INVITE, REGISTER} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";


const Invite = ({auth}) => {
    const [copySuccess, setCopySuccess] = useState('');
    const textAreaRef = useRef(null);
    useEffect(() => {
        document.title = "Invite | Prime Private Network";
    });

    function copyToClipboard(e) {
        textAreaRef.current.select();
        document.execCommand('copy');
        // This is just personal preference.
        // I prefer to not show the the whole text area selected.
        e.target.focus();
        setCopySuccess('Copied!');
    };
    return (
        <Fragment>
            <Navbar scenario={INVITE}/>
            <HeroSection title="Invite"/>
            <div className="container">
                <div className="invite-container">
                    <div className="row justify-content-center mt-lg-5 mt-2">
                        <div className="col-lg-6 col-12">
                                <div className="default-invite--container text-center">
                                    <img src={image} alt=""/>
                                </div>
                        </div>
                        <div className="col-lg-6 col-12 mx-auto my-auto">
                            {
                                /* Logical shortcut for only displaying the
                                   button if the copy command exists */
                                document.queryCommandSupported('copy') &&
                                <div className="text-success">
                                    {copySuccess}
                                </div>
                            }

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="ml-2">Copy & Paste link to sent invitation to invite </label><i
                                className="far fa-copy ml-3 cursor-pointer" onClick={copyToClipboard}/>
                                <input type="text" className="form-control cursor-pointer"
                                       onClick={copyToClipboard}
                                       ref={textAreaRef}
                                       value={`${BASE_URL}/register/${auth.user._id}`}/>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};


const mapStateToProps = (state) => ({
    auth: state.auth,
    property: state.property,
});

export default connect(mapStateToProps, {})(Invite)

